import { RestaurantAggregateResponseData, AreaBranches } from './models/restaurant.model';
import { cookies, setCookie } from './constants/constants';

const pickData = window['pickData'];
let serverData;
if (typeof pickData != 'undefined') {
  pickData.xTracking ? setCookie(cookies.xTracking, JSON.stringify({ uuid: pickData.xTracking, index: null }), '/', '') : setCookie(cookies.xTracking, '', '/', '');
  if(pickData.menus){

  }

  serverData = {
    restaurantUUID:pickData.restaurantUUID,
    restaurantHeader: <RestaurantAggregateResponseData> pickData.restaurantHeader,
    lookups: pickData.lookups,
    onlineOrderingFilterOpen: pickData.onlineOrderingFilterOpen,
    deliveryRestaurants: pickData.deliveryRestaurants,
    deliveryLookups: pickData.deliveryLookups,
    searchResults: pickData.searchResults,
    dineoutRestaurants: pickData.dineoutRestaurants,
    hiddenRestaurants: pickData.hiddenRestaurants,
    newRestaurants: pickData.newRestaurants,
    moodRestaurants: pickData.moodRestaurants,
    categoryRestaurants: pickData.categoryRestaurants,
    selectedDish:pickData.selectedDish,
    openedGiftForm:pickData.openedGiftForm,
    offersRestaurants:pickData.offersRestaurants,
    cvmRestaurants:pickData.cvmRestaurants,
    cvmPromoData:pickData.cvmPromoData,
    deliveryCategories:pickData.deliveryCategories,
    userNotHasArea: pickData.userNotHasArea,
    dineoutPageMethod: pickData.dineoutPageMethod,
    dineoutCategories: pickData.dineoutCategories,
    dineoutMoods: pickData.dineoutMoods,
    currentOrders: pickData.currentOrders,
    previousOrders: pickData.previousOrders,
    profile: pickData.profile,
    promoBanner:pickData.promoBanner,
    xTracking: pickData.xTracking,
    reviewDetails: pickData.reviewDetails,
    restaurantBaseUrl: pickData.restaurantBaseUrl,
    deliveryHours: pickData.deliveryHours,
    urlAreaUUID: pickData.urlAreaUUID,
    workingHours: pickData.workingHours,
    order: pickData.order,
    trip:pickData.trip

  }
  pickData.userNotHasArea ;
  window['pickData'] = null;
  document.getElementById('script-should-remove').remove();
}
export {serverData};

